import { PureComponent } from "react";

import yup from "utilities/form/yup";

import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    type GridColumn,
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";
import TextTruncate from "commonComponents/utilities/TextTruncate/TextTruncate";

interface IDangerousHTML {
    html: string;
    plainText: string;
}

type DangerousHTMLCellType = IDangerousHTML | undefined;

class DangerousHTMLCell extends PureComponent<
    IGridCellRenderProps<DangerousHTMLCellType, GridColumn<DangerousHTMLCellType>>
> {
    render() {
        const { cellValue, column, isInEdit } = this.props;
        if (!cellValue?.plainText) {
            return null;
        }
        const content = (
            <span
                className="column-html-truncate"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: cellValue?.html || "",
                }}
            />
        );
        return !isInEdit ? (
            <TextTruncate popoverContent={content}>{cellValue?.plainText}</TextTruncate>
        ) : (
            <BTAlert
                message={`Unimplemented Edit control:'${column.columnType}', value:${JSON.stringify(
                    cellValue,
                )}`}
                type="warning"
                data-testid="htmlUnimplementedEditControl"
            />
        );
    }
}

export const columnDangerousHTML: IClientGridColumn<DangerousHTMLCellType> = {
    validationSchema: yup.mixed(),
    columnType: GridColumnType.dangerousHTML,
    Cell: DangerousHTMLCell,
};
